import { memo } from "react";
import Breadcrumb from "./Breadcrumb.jsx";

const Header = ({ title, links, margin, children, style, flex }) => {
  return (
    <header className={style ? style : "mb-6"}>
      <Breadcrumb links={links} />

      <div
        className={`mt-0 items-center justify-between print:mb-9 print:p-0 ${
          !margin ? "mt-0" : ""
        } ${flex ? "flex" : "block sm:flex"}`}
      >
        {title && <h1 className="page-title mb-2 md:mb-0">{title}</h1>}
        {children}
      </div>
    </header>
  );
};

export default memo(Header);
